import React, { useEffect, useState, useContext } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axiosRest';
import Confetti from 'react-confetti';
import { AuthContext } from '../../context/AuthContext';

export default function Success() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState(null);
  const [countdown, setCountdown] = useState(3);
  const navigate = useNavigate();
  const { refreshAuthState } = useContext(AuthContext);

  useEffect(() => {
    const verifySubscription = async () => {
      try {
        const response = await axiosInstance.get(`/payment/subscription-success/?session_id=${sessionId}`);
        setStatus(response.data.message);
        
        // Refresh auth state after successful verification
        await refreshAuthState();
        
        // Set a timeout for redirect
        setTimeout(() => {
          navigate('/auth', { replace: true });
        }, 3000);
        
      } catch (error) {
        console.error('Error verifying subscription:', error);
        setStatus('Failed to verify subscription.');
      }
    };

    if (sessionId) {
      verifySubscription();
    }

    const countdownInterval = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown <= 1) {
          clearInterval(countdownInterval);
        }
        return prevCountdown - 1;
      });
    }, 1000);

    // Clean up interval
    return () => {
      clearInterval(countdownInterval);
    };
  }, [sessionId, navigate, refreshAuthState]);

  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
      <Confetti />
      <h1>Subscription Successful!</h1>
      {status ? <p>Status: {status}</p> : <p>Verifying your subscription...</p>}
      <p>Redirecting in {countdown} seconds...</p>
    </div>
  );
}
